module.exports = __webpack_public_path__ + "static/media/G-button.30bc141e.svg";